module.exports = __webpack_public_path__ + "img/new_customers_orders.c085d942.svg";